export const GOALS = {
  no_setup_found: 1,
  cta_overall: 2,
  load_product_selection: 3,
  load_personal_data: 4,
  load_address: 5,
  load_financial_information: 6,
  load_additional_services: 7,
  load_beneficial_owner: 8,
  load_information_recap: 9,
  load_confirm: 10,
  load_id_upload: 11,
  load_contract_view: 12,
  load_digital_signature: 13,
  load_success_digital_signature: 14,
  load_success_print_service_no_doc: 15,
  load_success_print_at_home: 16,
  load_no_card_possible: 17,
  load_generic_error: 18,
  load_charge_confirmation: 19,
  load_success_email_request: 20,
  load_success_print_service: 21,
  load_success_digital_signature_charge: 22,
  load_success_digital_signature_no_doc: 23,
  load_success_digital_signature_charge_no_doc: 24,
  load_success_email_print_overall: 25,
  load_success_digital_signature_overall: 26,
  load_charge_success_overall2: 27
}
